import React from 'react';

const Footer = () => {
  return (
    <div className="slim-footer mg-t-0">
      <div className="container-fluid">
        <p>Copyright 2024 © All Rights Reserved. ICOC</p>
        <p>Designed by: <a href="http://interactivecoc.com/" target='_blank' rel="noopener noreferrer">Interactive COC</a></p>
      </div>
    </div>
  );
}

export default Footer;